.countdown {
  display: inline-flex;
  flex: none;
  align-items: center;
  gap: var(--zumpo-space-8);
  height: 44px;
  padding: var(--zumpo-space-10) var(--zumpo-space-18) var(--zumpo-space-10)
    var(--zumpo-space-14);
  border-radius: var(--zumpo-radius-999);
  background: var(--zumpo-lime);
  color: var(--zumpo-ink);
  white-space: nowrap;
}

.time {
  font: var(--zumpo-text-number);
  letter-spacing: var(--zumpo-text-number-tracking);
}

/* DM Sans has no tabular figures, so each digit gets a cell as wide as the
   widest one, 0, and the clock keeps its width as it ticks. */
.digit {
  display: inline-block;
  width: 1ch;
  text-align: center;
}

.label {
  font: var(--zumpo-text-label);
  letter-spacing: var(--zumpo-text-label-tracking);
}

.waiting {
  background: var(--zumpo-sand);
}

/* Info: a clock that ends nothing, drawn as a line on the bar's paper. */
.info {
  box-shadow: inset 0 0 0 1px var(--zumpo-line);
  background: transparent;
}

.urgent {
  background: var(--zumpo-peach);
  color: var(--zumpo-danger);
}
